'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigation', ['$scope', '$state', '$stateParams', 'Complaints', function ($scope, $state, $stateParams, Complaints) {
        $scope.masterInvestigation = $stateParams.investigation;
        $scope.investigation = $stateParams.investigation;
        $scope.investigationID = $stateParams.id;
        $scope.investigationLoading = true;
        $scope.deleting = false;

        $scope.setMasterInvestigation = function (investigation) {
            $scope.masterInvestigation = investigation;
            $scope.investigation = angular.copy($scope.masterInvestigation);
        }

        $scope.resetInvestigation = function () {
            if ($scope.masterInvestigation == null) {
                $scope.masterInvestigation = {};
            }
            $scope.investigation = angular.copy($scope.masterInvestigation);
        }

        $scope.getInvestigation = function () {
            $scope.investigationLoading = true;

            Complaints.getByID($stateParams.id).then(function (investigation) {
                $scope.investigationLoading = false;
                $scope.setMasterInvestigation(investigation);
            })
        }

        $scope.delete = function () {
            $scope.deleting = true;

            if (window.confirm('Are you sure you want to delete this investigation?')) {
                Complaints.delete($scope.investigationID).then(function () {
                    $scope.deleting = false;
                    $state.go('internal.licensing.investigations');
                })
            }
            else {
                $scope.deleting = false;
            }
        }
        
        if ($stateParams.id != null) {
            $scope.getInvestigation();
        }
        else {
            var investigation = {};
            investigation.users = [];
            investigation.services = [];
            investigation.vehicles = [];
            investigation.alerts = [];

            if ($stateParams.user != null) {
                investigation.users.push({ id: $stateParams.user.id, name: $stateParams.user.name, nameandnumber: $stateParams.user.nameandnumber });
            }
            if ($stateParams.service != null) {
                investigation.services.push({ id: $stateParams.service.id, name: $stateParams.service.name, nameandnumber: $stateParams.service.nameandnumber });
            }
            if ($stateParams.vehicle != null) {
                investigation.vehicles.push({ id: $stateParams.vehicle.id, name: $stateParams.vehicle.name, nameandnumber: $stateParams.vehicle.nameandnumber });
            }

            $scope.investigationLoading = false;
            $scope.setMasterInvestigation(investigation);
        }
    }])
;